module.exports = __webpack_public_path__ + "static/media/perplexity.ec51cc98.svg";